class QuizManager {

	constructor() {
		this.answers = new Map(); //vyklikane odpovede
        this.correctAnswers = new Map(); //spravne odpovede podla dat zo servera, tieto sa pouziju na vyhodnotenie spravnosti 
        this.evaluatedAnswers = new Map();  //vyhodnotene odpovede, vid EVALUATED_ANSWER konstanty
        this.isRunningFlag = false;
        this.isFinishedFlag = false;
        this.quizType = null; //aktualny typ kvizu, vid config.js
        this.exampleIDs = [];
        this.exampleNazovObecCob = [];
        this.resultPercentage = 0;
        this.evaluateTable = '';

//        this.obecCob2exampleID = {};

        this.dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);
    }

    // zacni kviz
    // predpokladame ze this.exampleIDs uz je nastavene pred startom
    start() {
        this.answers.clear();
        this.correctAnswers.clear();
        this.isRunningFlag = true; 
        this.isFinishedFlag = false;
        this.resultPercentage = 0;
    }

    setQuizType(quizType) {
        this.quizType = quizType;
    }

    getQuizType() {
        return this.quizType;
    }

    // nastav example IDs (ukazky na mape) podla Markers REST response
    setExampleIDsByMarkers(json) {
        this.exampleIDs = [];
        this.exampleNazovObecCob = [];

		for (let i = 0; i < json.features.length; i++) {
			const feature = json.features[i];
			const exampleId = feature.properties.EXAMPLE_ID;
            this.exampleIDs.push(exampleId);
            var nazovObecCob = feature.properties.NAZ_OBEC || '';
            const nazovCob = feature.properties.NAZ_COB || '';
            if (nazovCob) {
                nazovObecCob = nazovCob + ", " + nazovObecCob;
            }
            this.exampleNazovObecCob.push(nazovObecCob);
        }
    }

    // nastav example IDs (ukazky na mape), na ktorych bude prebiehat kviz 
    setExampleIDs(exampleIDs) {
        this.exampleIDs = exampleIDs;
    }

    isExampleIdIncluded(exampleId) {
        return this.exampleIDs.includes(exampleId);
    }

    isRunning() {
        return this.isRunningFlag;
    }

    isFinished() {
        return this.isFinishedFlag;
    }

    // ukonci a vyhodnot kviz
    finish() {
        this.isRunningFlag = false;
        this.isFinishedFlag = true;
        this.evaluate();
    }

    //resetni kviz, priprava na dalsi kviz
    reset() {
        this.isRunningFlag = false;
        this.isFinishedFlag = false;
        this.answers.clear();
        this.correctAnswers.clear();
        this.evaluatedAnswers.clear();
        this.resultPercentage = 0;
        this.resultText = '';
        this.evaluateTable = '';
    }


    getResultPercentage() {
        return this.resultPercentage;
    }

    getResultText() {
        return this.resultText; 
    }

    getEvaluateTable() {
        return this.evaluateTable;
    }

    getProgress() {
        const allQuestions =  this.exampleIDs.length; 
        var answeredQuestions = 0;
        this.exampleIDs.forEach(item => {
            if (this.hasAnswer(Number(item))) {answeredQuestions++;}
        })
        var res = answeredQuestions + " / " + allQuestions; 
        return res;
    }

    // su vsetky odpovede uz vyklikane ?
    isAllAnswers() {
        const allQuestions =  this.exampleIDs.length; 
        var answeredQuestions = 0;
        this.exampleIDs.forEach(item => {
            if (this.hasAnswer(Number(item))) {answeredQuestions++;}
        })
        return (answeredQuestions == allQuestions); 
    }

    getAnswer(key) {
        return this.answers.get(Number(key));
    }

    hasAnswer(key) {
        return this.answers.has(Number(key));
    }

    setAnswer(key, answer) {
        this.answers.set(Number(key), answer);

    }

    
    getCorrectAnswer(key) {
        return this.correctAnswers.get(Number(key));
    }

    hasCorrectAnswer(key) {
        return this.correctAnswers.has(Number(key));
    }

    setCorrectAnswer(key, answer) {
        this.correctAnswers.set(Number(key), answer);
    }


    getEvaluatedAnswer(key) {
        return this.evaluatedAnswers.get(Number(key));
    }

    hasEvaluatedAnswer(key) {
        return this.evaluatedAnswers.has(Number(key));
    }

    setEvaluatedAnswer(key, evaluation) {
        this.evaluatedAnswers.set(Number(key), evaluation);
    }

    isRegionalQuiz() {
        return ['quiz_zapad', 'quiz_stred', 'quiz_vychod'].includes(this.quizType);
    }


    // private methods ========================================

    getDialectFullPath(dialectId) {
		let dialect = this.dialects[dialectId];
		const path = [];

		while (dialect) {
			path.unshift(dialect);
			dialect = this.dialects[dialect.parent_id] || null;
		}

		return path;
    }

    getPointsForAnswer(answer, correctAnswer, answerPath, correctAnswerPath) {
        const answerByLevel = {};
        answerPath.forEach(item => { answerByLevel[item.level] = item.id; });

        let points = 0;
        correctAnswerPath.forEach(item => {
            if (this.isRegionalQuiz() && item.level === 'oblast') {
                return; //tento return tu funguje ako continue - pokracujeme na dalsiu forEach iteraciu. Pre regionalne kvizy nedavame body za toplevel - lebo vsetky v kvize maju rovnaky toplevel
            }
            if (answerByLevel[item.level] === item.id) {
                points++;
            }
        });

        return points;
    }

    evaluate() {
        //vyhodnotenie kvizu - ci su vyklikane odpovede spravne
        //porovname answers a correctAnswers, nakolko sa zhoduju
        //ak sa zhoduje aspon makroareal napr, dam nejake body aj za to

        const allQuestions =  this.exampleIDs.length; 
        var points = 0;
        var possiblePoints = 0; 

        var evaluateTable = `<table class="sidepanel-card__table--dark" style="width:100%; table-layout:fixed; word-wrap:break-word;"><tr><th>Ukážka</th><th>Tvoja odpoveď</th><th>Správna odpoveď</th><th>Body</th></tr>`;

        for (let i = 0; i < this.exampleIDs.length; i++) {
            const item = this.exampleIDs[i];
            if (this.hasAnswer(Number(item)) && this.hasCorrectAnswer(Number(item))) {
                const answer = this.getAnswer(Number(item));
                const correctAnswer = this.getCorrectAnswer(Number(item));
                const answerPath = this.getDialectFullPath(answer);
                const correctAnswerPath = this.getDialectFullPath(correctAnswer);                
                var thisPoints = this.getPointsForAnswer(answer, correctAnswer, answerPath, correctAnswerPath);
                var thisPossiblePoints = this.isRegionalQuiz() ? 2 : 3; //v regionalnom kvize max 2 body, v celoslovenskom max 3 body
                points += thisPoints;
                possiblePoints += thisPossiblePoints; 

                const answerDialectName = (answerPath.find(i => i.level === 'usek') || {}).name || '';
                const correctAnswerDialectName = (correctAnswerPath.find(i => i.level === 'usek') || {}).name || '';
                const nazovObecCob = this.exampleNazovObecCob[i] || ''; 

                this.setEvaluatedAnswer(item, {
                    nazovObecCob: nazovObecCob,
                    points: thisPoints,
                    possiblePoints: thisPossiblePoints,
                    answerPath: answerPath,
                    correctAnswerPath: correctAnswerPath,
                    answerDialectName: answerDialectName,
                    correctAnswerDialectName: correctAnswerDialectName,
                });

                evaluateTable += `<tr><td>${nazovObecCob}</td><td>${answerDialectName}</td><td>${correctAnswerDialectName}</td><td>${thisPoints} / ${thisPossiblePoints}</td></tr>`;

/*                 if (answer == correctAnswer) {
                    goodAnswers++;
                    this.setEvaluatedAnswer(item, this.EVALUATED_ANSWER_GOOD);
                } else {
                    this.setEvaluatedAnswer(item, this.EVALUATED_ANSWER_BAD);
                } //TODO: semigood */
            }

        }
        evaluateTable += `</table>`;
        this.evaluateTable = evaluateTable;

        var res = Math.round((points/possiblePoints) * 100.0);
        this.resultPercentage = res;
        this.resultText = '';

        if (res < 20) {
            this.resultText = 'Slovenské nárečia sú poriadna výzva, ale to je na nich to krásne! Nevešaj hlavu a skús iný typ kvízu.'
        } else if (res < 40) {
            this.resultText = 'Dobrý začiatok! Slovenské nárečia majú čo ponúknuť, objav ich viac v aplikácii Mapka alebo vyskúšaj iný typ kvízu.'
        } else if (res < 60) {
            this.resultText = 'Pekný výsledok! V slovenských nárečiach sa dokážeš solídne orientovať. Vyskúšaj ďalší kvíz a posúvaj svoje hranice!'
        } else if (res < 80) {
            this.resultText = 'Výborný výsledok! Slovenské nárečia ti dajú zabrať len zriedka. Ak máš odvahu, dokáž, že to nebola len šťastena! Vyskúšaj ďalší typ kvízu.'
        } else {
            this.resultText = 'Bravó! V slovenských nárečiach sa vyznáš ako málokto – z teba by bol výborný dialektológ!'
        }
    }

}

export default new QuizManager();
